/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect } from 'react';
import {
  View,
  TouchableHighlight,
  StyleSheet,
  Linking,
  Platform,
} from 'react-native';

import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { States } from '../types/props';
import DyteText from './DyteText';
import DyteClient from '@dytesdk/web-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  if (!meeting) return null;
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const mediaAudioPermission = meeting.self.mediaPermissions.audio ?? {};
  const mediaVideoPermission = meeting.self.mediaPermissions.video ?? {};
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const handleOpenSettings = () => {
    if (Platform.OS === 'ios') {
      Linking.openURL('app-settings:');
    } else {
      Linking.openSettings();
    }
  };
  const continueToSetupScreen = () => {
    setStates({
      ...storeStates,
      permissionGranted: true,
    });
  };
  const styles = StyleSheet.create({
    container: {
      backgroundColor: colors.background[800],
      padding: 16,
      borderRadius: 8,
      margin: 8,
    },
    iconText: {
      flexDirection: 'row',
      marginVertical: 10,
      justifyContent: 'space-evenly',
    },
    contentText: {
      alignItems: 'center',
      justifyContent: 'center',
      marginVertical: 10,
    },
    buttonContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 10,
    },
    buttons: {
      flex: 1,
      paddingVertical: 8,
      marginHorizontal: 4,
      borderRadius: 8,
      alignItems: 'center',
    },
    text: {
      marginLeft: '5%',
      fontWeight: 'bold',
    },
  });
  return (
    <View style={styles.container}>
      <View style={styles.iconText}>
        <SvgXml
          xml={iconPack.warning.replace('currentColor', colors.danger)}
          width={25}
          height={25}
        />
        <DyteText size="xl" style={styles.text}>
          {t('perm_sys_denied')}
        </DyteText>
      </View>
      <View style={styles.contentText}>
        <DyteText>
          {mediaAudioPermission === 'DENIED' &&
            mediaVideoPermission === 'ACCEPTED' &&
            t(`perm_sys_denied.audio.${Platform.OS}.message`)}
          {mediaAudioPermission === 'ACCEPTED' &&
            mediaVideoPermission === 'DENIED' &&
            t(`perm_sys_denied.video.${Platform.OS}.message`)}
          {mediaAudioPermission === 'DENIED' &&
            mediaVideoPermission !== 'ACCEPTED' &&
            t(`perm_sys_denied.audio_video.${Platform.OS}.message`)}
        </DyteText>
      </View>
      <View style={styles.buttonContainer}>
        <TouchableHighlight
          underlayColor={colors.background[800]}
          style={{
            ...styles.buttons,
            backgroundColor: colors.background[700],
          }}
          onPress={() => continueToSetupScreen()}
        >
          <DyteText>{t('cta.continue')}</DyteText>
        </TouchableHighlight>
        <TouchableHighlight
          underlayColor={colors.background[800]}
          style={{
            ...styles.buttons,
            backgroundColor: colors.brand[500],
          }}
          onPress={() => handleOpenSettings()}
        >
          <DyteText>Go to Settings</DyteText>
        </TouchableHighlight>
      </View>
    </View>
  );
}
